#@import GliveBooking.Presenters.SectionPicker
#@import GliveBooking.Views.Picker
#@import GliveBooking.Views.Sections
#@export GliveBooking.Views.SectionPicker

class GliveBooking.Views.SectionPicker extends GliveBooking.Views.Picker

  module: 'glive-booking'

  presenter: GliveBooking.Presenters.SectionPicker

  contentView: GliveBooking.Views.Sections

  templateName: 'sectionpicker'

  attributes: ->
    'data-bhw': "#{GliveBooking.bhw}Sections"

  styleClassName: 'sections'
